/**
 * Machine-readable payment-method error codes from the API (PBI #1181).
 * Must match ScheduledSmiles.Api.Constants.PaymentMethodErrorCodes.
 */
export const PaymentMethodErrorCodes = {
  PaymentMethodRequired: 'PAYMENT_METHOD_REQUIRED',
} as const;

export type PaymentMethodErrorCode =
  (typeof PaymentMethodErrorCodes)[keyof typeof PaymentMethodErrorCodes];
